module.exports = __webpack_public_path__ + "img/no.64a08dcb.svg";